export default __webpack_public_path__ + "static/juice2-69a1c4c7ddbc26b249709470e9f30454.png";